// Host window for browser push notification popup.
import { useEffect, useRef, useState } from "react";
import { arePushNotificationsHandledOnHostSite, getUserHasHandledPushNotificationDialog } from "./pushNotificationUtils.web";
import { useDatastore } from "util/datastore";
import { callServerApiAsync } from "system/servercall";
import { BrowserPushPermissionState, getPublicWebPushKey, PermissionPopup, usePushNotificationPermission } from "open-modules/zdf/component/notifications/pushnotification";

export function requestBrowserNotificationInformation() {
    window.parent.postMessage({ type: "psi-request-browser-notification-permission-information" }, "*")
}

export function fetchBrowserPushNotificationTokenIframe() {
    window.parent.postMessage({ type: 'psi-request-browser-notification-token', PUBLIC_PUSH_KEY: getPublicWebPushKey() }, '*');
}


function useHandleFetchTokenIframeMessage(onRegisterToken) {
    const callback = useRef(onRegisterToken)
    callback.current = onRegisterToken;
    useEffect(() => {
        const handleMessage = async (event) => {
            if (event.data.type === 'psi-return-browser-notification-token') {
                callback.current(event.data)
            }
        };
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return {};
}

function useHandleFetchPermissionIframeMessage(onReceivePermissionData) {
    const callback = useRef(onReceivePermissionData)
    callback.current = onReceivePermissionData;
    useEffect(() => {
        const handleMessage = async (event) => {
            if (event.data.type === "psi-return-browser-notification-permission-information") {
                callback.current(event.data)
            }
        };
        window.addEventListener('message', handleMessage);
        requestBrowserNotificationInformation()
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return {};
}


// FIXME: This function is too large and should be broken up
/* eslint-disable-next-line max-lines-per-function */
export function PermissionPopupHost({onAllow, onNotAllow}){
    const pushNotificationsOnParentWindow = arePushNotificationsHandledOnHostSite()
    const datastore = useDatastore()
    const [permission, setPermission] = useState<BrowserPushPermissionState | undefined>("default")
    const [hasOptedOut, setHasOptedOut] = useState(getUserHasHandledPushNotificationDialog())
    const globalPushNotificationSetting = usePushNotificationPermission()
    const [iframePermissionReceived, setIframePermissionReceived] = useState(false)

    const [loading, setLoading] = useState(false)

    const hideModal = globalPushNotificationSetting===undefined || !iframePermissionReceived || hasOptedOut || (permission === "granted" && globalPushNotificationSetting)

    const updatePermissionData = () => {
        setHasOptedOut(getUserHasHandledPushNotificationDialog())
        requestBrowserNotificationInformation()
    }


    const onReceiveTokenFromIframe = async (eventData) => {
        setLoading(false)
        if(eventData.token){
            await callServerApiAsync({datastore, component: "pushNotifications", funcname: "savePushToken", params:{
                token: eventData.token
            }})
            onAllow && onAllow()
        } else {
            console.log("Permission denied")
        }
    }

    const onReceivePermissionFromIframe = async (eventData: {permission?: BrowserPushPermissionState}) => {
        if(!pushNotificationsOnParentWindow) return
        setPermission(eventData.permission)
        setIframePermissionReceived(true)
    }

    const handleAllow = () => {
        if(permission === "denied") {
            onAllow && onAllow()
            localStorage.setItem("doNotShowPushNotificationDialogAgain", "true");
            updatePermissionData()
            return
        }
        setLoading(true)
        fetchBrowserPushNotificationTokenIframe()
    }

    const handleNotAllow = () => {
        localStorage.setItem("doNotShowPushNotificationDialogAgain", "true");
        onNotAllow && onNotAllow();
        updatePermissionData()
    }

    useHandleFetchTokenIframeMessage(onReceiveTokenFromIframe)
    useHandleFetchPermissionIframeMessage(onReceivePermissionFromIframe)

    if(hideModal) return null

    return <PermissionPopup handleAllow={ handleAllow} handleNotAllow={handleNotAllow} permission={permission} loading={loading}/>
}